import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import Select from 'react-select';
import APIserver from '../../../../api/axiosConfig';
import Swal from 'sweetalert2';

const EditProductoTienda = ({ showEdit, handleCloseEdit, productoTiendaId, producto, referencia, categoria }) => {
    const [referenciaState, setReferencia] = useState('');
    const [categoriaState, setCategoriaState] = useState([]);  
    const [refOptions, setRefOptions] = useState([]);
    const [categoriaOptions, setCategoriaOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    // Depuración inicial: Verificar datos que recibe el componente
    console.log("EditProductoTienda recibe:", { productoTiendaId, producto, referencia, categoria });

    useEffect(() => {
        const fetchReferencias = async () => {
            try {
                const response = await APIserver.get('/api/referenciased');
                setRefOptions(response.data);
                if (referencia) {
                    setReferencia({ value: referencia, label: referencia });
                }
            } catch (error) {
                console.error('Error al obtener referencias:', error);
            }
        };

        const fetchCategorias = async () => {
            try {
                const response = await APIserver.get('/api/categoria');
                if (Array.isArray(response.data)) {
                    const opcionesCategorias = response.data.map(cat => ({
                        value: cat.idCategoria, 
                        label: cat.nomCategoria
                    }));
                    setCategoriaOptions(opcionesCategorias);

                    // Depuración: Verificar qué categorías trae el producto
                    console.log("Categorías obtenidas desde API:", response.data);
                    console.log("Categoría del producto:", producto?.categorias);

                    if (producto && Array.isArray(producto.categorias)) {
                        const categoriasSeleccionadas = producto.categorias.map(cat => ({
                            value: cat.idCategoria,
                            label: cat.nomCategoria
                        }));
                        setCategoriaState(categoriasSeleccionadas);
                        console.log("Categorías seleccionadas para el producto:", categoriasSeleccionadas);
                    }
                } else {
                    console.error('La respuesta de categorías no es un array:', response.data);
                }
            } catch (error) {
                console.error('Error al obtener categorías:', error);
            }
        };

        if (showEdit) {
            fetchReferencias();
            fetchCategorias();
        }
    }, [showEdit, productoTiendaId, referencia]);

    useEffect(() => {
        if (categoria && Array.isArray(categoria)) {
            setCategoriaState(categoria);
            console.log("Se asignaron categorías desde prop `categoria`:", categoria);
        }
    }, [categoria]);    

    useEffect(() => {
        if (refOptions.length > 0 && categoriaOptions.length > 0) {
            setLoading(false);
        }
    }, [refOptions, categoriaOptions]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const updatedProduct = {
                referencia: referenciaState.value,
                categorias: categoriaState.map(cat => cat.value)
            };            

            console.log("Datos enviados a la API:", updatedProduct);

            const response = await APIserver.put(`/api/productosTienda/${productoTiendaId}`, updatedProduct);

            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Producto actualizado!',
                    text: 'El producto se ha actualizado correctamente.',
                    showConfirmButton: false,
                    timer: 1000,
                }).then(() => {
                    window.location.reload();
                });
                handleCloseEdit();
            } else {
                console.error("Error al actualizar el producto");
            }
        } catch (error) {
            console.error("Error al enviar la actualización", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un error al actualizar el producto.',
                showConfirmButton: false,
                timer: 1000,
            });
        }
    };

    return (
        <Modal show={showEdit} onHide={handleCloseEdit} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Editar Producto Tienda</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col>
                            <Form.Group controlId="formReferencia" className='m-3 mt-0'>
                                <Form.Label>Referencia</Form.Label>
                                <Select
                                    options={refOptions}
                                    value={referenciaState}
                                    onChange={setReferencia}
                                    placeholder="Selecciona una referencia"
                                    isLoading={loading}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="formCategoria" className='m-3 mt-0'>
                                <Form.Label>Categoria</Form.Label>
                                <Select
                                    options={categoriaOptions}
                                    value={categoriaState.length ? categoriaState : null}
                                    onChange={setCategoriaState}
                                    placeholder="Selecciona una o varias categorías"
                                    isMulti
                                    isLoading={loading}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Modal.Footer>
                        <Button variant="dark" onClick={handleCloseEdit}>Cancelar</Button>
                        <Button variant="danger" type="submit">Guardar</Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditProductoTienda;
